import React from "react"
import { NextSeo } from "next-seo"
import styled from "styled-components"
import Layout from "~/components/Pages/Basic"
import {NextLink} from "~/components/Link"
import Breadcrumbs from "~/components/Breadcrumbs"
import { INFORMATION_BASE_PATH, STATES, STATE_COURT_MAP, STATE_GENERAL_MAP } from "~/components/traffic-tickets/information/constants"
import objectIsEmpty from "~/utilities/objectIsEmpty"
import {TRAFFIC_STATES_URL_SLUGS} from "~/utilities/constants"

const MainHeading = styled.h1`
  text-align: center;
`

const MainContent = styled.div`
  display: flex;
  justify-content: space-between;
`

const Column = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`

const SimpleList = styled.ul`
  list-style-type: none;
  padding: 0px;
  width: 100%;
`

const InfomationLandingPage = () => {
  // Submission Flow links (Information) 
  const submissionLinks = Object.keys(TRAFFIC_STATES_URL_SLUGS).map(key => {
    const state = TRAFFIC_STATES_URL_SLUGS[key]
    const { title } = state

    return (
      <li key={key}>
        <NextLink
          href={`/${key}-traffic-tickets`}
          as={`/${key}-traffic-tickets`}
          passHref
        >{title}
        </NextLink>
      </li>
    )})


  // Court links
  const courtLinks = Object.keys(STATE_COURT_MAP).sort().map(key => {
    const state = STATES[key]
    const courts = STATE_COURT_MAP[key]

    if (!state || objectIsEmpty(courts)) {
      return null
    }

    return (
      <li key={key}>
        <NextLink
          href={`/traffic/information/${state.longName.toLowerCase()}-courts`}
          as={`/traffic/information/${state.longName.toLowerCase()}-courts`}
          passHref
        >{state.title} Courts
        </NextLink>
      </li>
    )})


  // Statute links
  const statuteLinks = []

  Object.keys(STATE_GENERAL_MAP).forEach((key) => {
    const contentObject = STATE_GENERAL_MAP[key]

    Object.keys(contentObject || []).forEach((slug) => {
      statuteLinks.push(
        <li key={slug}>
          <NextLink
            href={`/traffic/information/${key}/${slug}`}
            as={`/traffic/information/${key}/${slug}`}
            passHref
          >{contentObject[slug].shortTitle || contentObject[slug].title} 
          </NextLink>
        </li>
      )
    })
  })


  return (
    <>
      <NextSeo title="Traffic Information | WinIt" />
      <Layout>
        <Breadcrumbs levels={[
          { title: "Home", href: INFORMATION_BASE_PATH}
        ]}
        />
        <MainHeading>Traffic Ticket Information by State</MainHeading>
        <MainContent>
          <Column>
            <h2>Ticket Information</h2>
            <SimpleList>{submissionLinks}</SimpleList>
          </Column>
          <Column>
            <h2>Courts</h2>
            <SimpleList>{courtLinks}</SimpleList>
          </Column>
          <Column>
            <h2>State Statutes</h2>
            <SimpleList>
              {statuteLinks}
            </SimpleList>
          </Column>
        </MainContent>
      </Layout>
    </>
  )
}

export default InfomationLandingPage
